import type { TFunction } from 'i18next';
import {
  BarChart3,
  Database,
  History,
  Settings,
  ShieldCheck,
  Users,
  type LucideIcon,
} from 'lucide-react';
import type { PermissionContext } from '@hooks/usePermissions';

export interface AdminSection {
  title: string;
  icon: LucideIcon;
  description: string;
  path: string;
  permission: boolean;
}

/**
 * Icons are carried as components, not elements: the MUI original built
 * elements here and painted them through the wrapper's `color`, which lucide
 * cannot inherit the same way — the glyph colour now lives with the wrapper.
 */
export const buildAdminSections = (
  t: TFunction,
  permissions: PermissionContext,
): AdminSection[] => [
  {
    title: t('admin.users'),
    icon: Users,
    description: t('admin.usersDescription'),
    path: '/admin/users',
    permission: permissions.canManageUsers,
  },
  {
    title: t('admin.settings'),
    icon: Settings,
    description: t('admin.settingsDescription'),
    path: '/admin/settings',
    permission: permissions.canManageSettings,
  },
  {
    title: t('admin.storage'),
    icon: Database,
    description: t('admin.storageDescription'),
    path: '/admin/storage',
    permission: permissions.canManageSettings,
  },
  {
    title: t('admin.security'),
    icon: ShieldCheck,
    description: t('admin.securityDescription'),
    path: '/admin/security',
    permission: permissions.canManageSettings,
  },
  {
    title: t('admin.analytics'),
    icon: BarChart3,
    description: t('admin.analyticsDescription'),
    path: '/admin/analytics',
    permission: permissions.canViewAuditLogs,
  },
  {
    title: t('admin.auditLogs'),
    icon: History,
    description: t('admin.auditLogsDescription'),
    path: '/admin/audit-logs',
    permission: permissions.canViewAuditLogs,
  },
  {
    title: t('admin.activityAudit'),
    icon: BarChart3,
    description: t('admin.activityAuditDescription'),
    path: '/admin/activity',
    permission: permissions.canViewAuditLogs,
  },
  {
    title: t('admin.anomalies'),
    icon: ShieldCheck,
    description: t('admin.anomaliesDescription'),
    path: '/admin/anomalies',
    permission: permissions.canViewAuditLogs,
  },
];
